export default {
  'homepage':{
    'titolo':'Libere-toi!',
    'sottotitolo':'Rencontrer de nouvelles personnes',
    'accedi':'Se connecter',
    'registrati':'S\'inscrire',
    'gia_registrato':'Si vous êtes déjà inscrit au service, connectez-vous:',
    'non_registrato':'Si vous n\'êtes pas encore inscrit, inscrivez-vous maintenant et commencez à rencontrer de nouvelles personnes!',
    'perche':'Pourquoi choisir',
    'trova':'Trouvez le single qui vous convient',
    'sicurezza':'Votre sécurité est importante pour nous',
    'aumenta_visibilita':'Augmentez la visibilité de votre profil',
    'cerca_persona_adatta':'Trouvez la bonne personne pour vous',
    'desc_sicurezza':'La protection de nos clients est une priorité absolue et nous faisons de notre mieux pour assurer une sécurité maximale sur notre site. Nous modérons chaque photo de profil et description. La protection de vos données personnelles est notre priorité.',
    'desc_visibilita':'Créez le profil parfait pour vos réunions en ligne. Plus votre profil sera visité, plus vous aurez de meilleures chances de rencontrer des personnes intéressantes!',
    'desc_persona_adatta':'Trouvez la personne qui vous convient grâce à la recherche détaillée et découvrez notre sélection personnalisée de profils détaillés.',
    'sezione_coppie':'Couples qui se sont rencontrés sur $servizio$'
  },
    'navbar_mobileNew': {
      'cerca': 'Chercher',
      'messaggi': 'Messages',
      'profilo':'Profil',
      'vip':'VIP',
      'registrati':'Enregistrez-vous',
      'incentive_menu':'Ajouter des crédits de message',
      'messaggi_restanti':'Crédits messages',
      'rimanenti':'restants',
      'logout':'Se déconnecter',
      'attiva_notifiche':'Activer les notifications',
      'crediti':'Crédits',
      'titolo_cerca':'CHERCHER',
      'titolo_match':'MATCH',
      'titolo_messaggi':'MESSAGES',
      'titolo_notifiche':'NOTIFICATIONS',
      'titolo_avvisi':'ALERTES',
      'titolo_profilo':'PROFIL',
      'titolo_rateplan':'AUGMENTER LES CRÉDITS',
      'profilo_angel':'PROFIL UTILISATEUR',
      'diventa_premium': 'DEVENEZ PREMIUM',

    },
    'chat_content': {
      'disponibile': 'disponible',
      'inserire_numero':'pour entrer un numéro, vous devez vous',
    'registrarti':'inscrire',
    'scrivi_un_messaggio':'écrire un message...',
    'rompi_il_ghiaccio':'Briser la glace!',
      'prova_con':'Essayez l\'un de ces messages que tout le monde utilise. Choisissez-le et envoyez-le',
      'messaggio1':'Bonjour, j\'aimerais voir vos photos privées',
      'messaggio2':'Comment vas tu? Voulez-vous parler un peu',
      'messaggio3':'J\'ai vu votre profil et j\'aimerais mieux vous connaître',
      'hook_blurred':'Lisez le message',
      'non_essere_timido':'$angel$ è disponibile.<br>Inviale un messaggio!',
      'sta_scrivendo':'est en train d\'écrire..',
      'ha_visitato':'<i class="far fa-eye"></i> a visité votre profil',
      'elimina_chat':'Supprimer la conversation',
      'sei_sicuro':'Êtes-vous sûr ?',
      'si':'Oui',
      'no':'Non'
    },
    'profilo': {
      'cambia_foto': 'Changer la photo',
      'username': 'Nom d\'utilisateur',
      'cambia': 'Changements',
      'cognome': 'Nom',
      'eta': 'Âge',
      'email': 'Email',
      'cerco': 'Je cherche',
      'sono': 'Sexe',
      'inserisci_numero': 'Veuillez entrer votre numéro de téléphone',
      'inserisci_username': 'Entrez votre nom d\'utilisateur',
      'inserisci_email': 'insérez votre email',
      'inserisci_citta': 'Entrez votre ville',
      'salva': 'Sauvegarder les modifications',
      'inserisci_eta': 'Votre âge',
      'cerco': 'Je recherche',
      'citta': 'Ville',
      'uomo':'Homme',
      'donna':'Femme',
      'scegli':'Choisissez..',
      'solo_immagini': 'Seules les images sont autorisées',
      'grandezza_file':'La photo doit faire moins de 10 Mo',
      'foto_non_conforme':'Photo rejetée : enfreint les règles de la plateforme',
      'foto_chat_non_conforme':'Message non envoyé : la photo enfreint les règles de la plateforme',
      'mail_esistente':'L\'e-mail sélectionné existe déjà',
      'seleziona_altra_mail':'Sélectionnez un autre e-mail pour mettre à jour correctement votre profil',
      'titolo_ok':'Modifications effectuées avec succès',
      'testo_ok':'Les modifications apportées à votre profil ont été effectuées correctement',
      'crediti_messaggi':'Crédits',
      'aggiungi':'Ajouter',
      'disiscrizione':'Se désabonner',
      'header_disiscrizione':'Fermer le service',
      'titolo_disiscrizione':'Voulez-vous continuer avec la baisse?',
      'descrizione_disiscrizione':'Vous perdrez toutes les opportunités de discuter avec de nouvelles filles et de vivre de nouvelles aventures épicées.',
      'disiscrizione_ok':'La désinscription a réussi',
      'disiscrizione_ko':'Une erreur s\'est produite lors de la phase de désabonnement, contactez le service client',
      'descrizione':'Description',
      'cosa_cerco':'Que cherchez-vous',
      'cambia_foto':'Changer la photo',
      'regione':'Elige tu comunidad',
      'utente_free':'Eres un usuario gratuito y tienes $icebreacker$ icebracker y $messaggi$ mensaje para responder. Conviértase en un usuario premium para recibir más mensajes',
      'diventa_premium':'Obtén premium ahora!',
      'impostazioni_profilo':'Paramètres de profil',
      'disattiva_profilo':'Désactiver le profil',
      'disattiva_profilo_ok':'Votre profil a été désactivé et n\'est plus visible par les autres utilisateurs. Vous allez être redirigé vers la page d\'accueil. Pour le réactiver, contactez le service client.',
      'torna_home':'Retour à la page d\'accueil',
      'sei_sicuro_disattiva_profilo':'Êtes-vous sûr de vouloir désactiver votre profil ?',
      'spiegazione-disattiva_profilo':'<div class="testo_popup_disattivazione">En désactivant votre profil, vous ne pourrez plus:<ul><li>accéder au service</li><li>être visible par les autres utilisateurs</li><li>utiliser vos crédits</li></ul>. Pour réactiver votre profil, vous devrez contacter le service client - <span style="font-weight:bold">Voulez-vous continuer?</span></div>',
      'si': 'Oui',
      'no': 'Non',
      'ricevute_acquisti': 'Reçus d\'achats',
      'gestione_notifiche': 'Gestion des notifications',
      'telegram': 'Telegram',
      'notifiche_push': 'Notifications push',
      'email_tracking': 'Pixel tracking',
      'stato_profilo': 'Statut du profil',
      'prossimo_addebito': 'Prochain débit',
      'supporto': 'Support',
    },
    'user': {
      'chat': 'Chat',
      'mi_piace': "J'aime",
      'anni': 'Age',
      'posizione': 'Location',
      'capelli': 'Cheveux',
      'altezza':'Taille',
      'peso': 'Poids',
      'descrizione': 'Description',
      'cerca': 'Chercher',
      'vicino_a_te':'Près de vous',
      'messaggi_rimanenti':'Messages restants',
      'incentive':'Inscrivez-vous pour recevoir plus de messages',
      'persona_interessata':'Cette personne pourrait être intéressée par vous!',
      'registrati_adesso':'Inscrivez-vous maintenant',
      'messaggi_illimitati':'de cette façon, vous pouvez envoyer des messages illimités et organiser une réunion',
      'blond':'Blonds',
      'brown':'Bruns',
      'red':'Roux',
      'darkblond':'Blonds foncés',
      'black':'Noirs',
      'colored':'Teints',
      'scrivile_in_privato':'Écrivez-lui en privé',
      'uomo':'Homme',
      'donna':'Femme',
      'segnala_blocca':'Signaler ou bloquer',
      'utente_bloccato':'🚫 Utilisateur bloqué et signalé, il ne pourra plus vous contacter',
    },
    'signup': {
      'registrazione': 'Enregistrez-vous',
      'immediata': 'Immédiatement',
      'incontri_segreti': 'Rencontres secrètes et discrètes...',
      'trova_ragazze': "Rejoignez des femmes qui, à travers une rencontre discrète, cherchent à s'évader pendant quelques heures.",
      'scegli_una_password': 'Choisir un mot de passe',
      'continua': 'CONTINUE',
     },
    'popupHook': {
      'utente_registrato': 'est un utilisateur enregistrée!',
      'incentive_1': "Pour pouvoir lui envoyer d'autres messages de chat et parler aux autres filles disponibles, inscrivez-vous gratuitement.",
      'incentive_2': "Pour pouvoir voir le numéro de mobile, inscrivez-vous maintenant.",
      'altri_profili': "Les utilisateurs premium peuvent afficher d'autres profils.",
      'incentive_3': "Pour rencontrer d'autres filles disponibles, inscrivez-vous maintenant.",
      'utenti_usano': 'La plupart de nos utilisateurs utilisent',
      'si_raccomanda': "Il est recommandé de s'inscrire",
      'cambiar_profilo': 'Les utilisateurs premium peuvent modifier leur profil',
      'per_cambiar_profilo': "Afin de modifier votre profil et d'ajouter le contact de",
      'registrati_adesso': 'enregistrez-vous maintenant',
      'gia_account':'Avez-vous déjà un compte?',
      'bentornato': 'Nous saluons le retour! Entrez vos informations d\'identification pour accéder au service',
      'registrati_home': 'Faites-vous des amis tout de suite et rencontrez des gens dans votre région!',
      'accedi_subito':'Connectez vous maintenant!',
      'continua':'CONTINUE',
      'blurred_title':'Voulez-vous lire le message de',
      'blurred_body':'a exprimé le désir de discuter uniquement avec des utilisateurs vérifiés comme elle.',
      'blurred_incentive':'Voulez-vous voir sa réponse et lui envoyer plus de messages immédiatement?',
      'espresso_desiderio': 'a exprimé le désir de connaître SEULEMENT les utilisateurs vérifiés comme vous',
      'vuoi_vedere':'Voulez-vous voir ses photos, ses détails et lui envoyer un message immédiatement?',
      'verifica_ora':'Vérifiez votre compte maintenant',
      'diventa_premium':'Devient premium',
      'verifica_profilo':'Vérifier le profil',
      'messaggio_non_mandato':'Le message n\'a pas pu être envoyé',
      'attiva_pass':'Activez votre PASS pour l\'envoyer IMMÉDIATEMENT',
      'attiva_lettura':'Voulez-vous savoir si <strong>$angel$</strong> lit vos messages ?',
      'ti_piace': 'Aimez-vous',
      'attiva_generico':'Activez votre pass pour LIKE unlimited, CHAT avec qui vous voulez, VOIR toutes les photos',
      'donne_regione':'Les utilisateurs VIP peuvent voir les profils d\'autres régions',
      'sottotitolo_regione':'Pour voir toutes les femmes en ligne également d\'une autre région, il est recommandé de devenir VIP',
      'messaggio_sospeso':'Message en attente',
      'attiva_pass_senza_limiti':'Activez votre PASS pour discuter sans limites',
      'per_scoprire':'Pour découvrir tout cela, <strong>$angel$</strong> veut que vous vérifiez votre compte en ce moment',
      'la_vuoi_conoscere':'Voulez-vous connaître ',
      'imposta_regione':'Sélectionnez une ville où vous souhaitez trouver des femmes pour votre prochain rendez-vous',
      'quasi_terminato':'Tu as presque fini!',
      'non_lasciare_sospeso': 'Ne laissez pas <strong>$angel$</strong> en suspens !',
      'altri_uomini': '<i>D\'autres hommes en ligne maintenant pourraient lui écrire.</i>',
      'utente_disabilitato':'Votre compte a été désactivé. Veuillez contacter le service client',

     },
     'popupNotifica':{
      'hai_ricevuto_messaggio':'Tu as reçu message',
      'da':'de',
      'rispondi':'Répondre',
      'profilo':'Profil',
      'hai_ricevuto_like':'vous a envoyé un LIKE !',
      'risposta_a_like':'a répondu à votre LIKE ! Envoie-lui un texto tout de suite',
      'ha_guardato_tuo_profilo':'a regardé votre profil récemment',
      'avvisami_risposta':'Préviens-moi quand elle répond',
      'avvisami_novita':'Préviens-moi des nouveautés',
      'visualizza':'Voir le profil'
    },
    'popupInfo':{
      'anni': 'Age',
     },
     'popupGenerico':{
      'chiudi': 'Fermer',
      'cambia_carta':'Changer de carte',
      'bentornato':'Bon retour, tu nous as manqué !',
      'regalo_messaggi':'C\'est pour cette raison que nous vous avons accordé quelques crédits. 💰 Discutez immédiatement avec qui vous voulez!',
     },
     'popupFoto':{
        'carica_foto': 'Ajoutez une photo de vous <br /> pour compléter votre profil',
        'incentivo':'Les utilisateurs avec une photo <br/>reçoivent <strong>7 fois plus de messages !</strong>',
        'lo_faro_dopo':'I will do it later'
      },
     'signupForm':{
       'caricando':'Chargement...',
       'scegli_una_password':'Choisir un mot de passe',
       'registrati_gratis':'Enregistrez-vous gratuitement',
       'accedi':'Se connecter',
       'gia_registrato':'Déjà inscrit?',
       'iscriviti':'Pas encore inscrit?',
       'password':'Mot de passe',
       'password_dimenticata':'Mot de passe oublié?',
       'indietro':'Retour connexion',
       'invia':'Envoyer',
       'introduci_mail_reset_password':'Entrez votre email pour démarrer le processus de réinitialisation du mot de passe',
       'email_inviata':'Vous avez reçu un lien vers votre adresse e-mail pour réinitialiser votre mot de passe.',
       'utente_inesistente':'L\'adresse saisie n\'existe pas',
       'mail_password_errati':'L\'email ou le mot de passe est incorrect',
       'sono': 'Je suis',
       'cerco':'Je cherche',
       'citta':'Ville',
       'email':'Insérez votre email',
       'suggerimento_citta':'Saisissez au moins trois caractères puis choisissez dans la liste',
       'errore_citta':'Ciudad no encontrada. Escribe los primeros tres caracteres de tu ciudad y selecciona de la lista',
       'errore_email':'Ciudad no encontrada',
      'errore_password':'Ciudad no encontrada',
      'regione':'Elige tu comunidad',
      'fr': 'Entrez votre âge',
      'errore_sono':'Complétez le champ "Je suis"',
      'errore_cerco':'Complétez le champ "Je cherche"',
      'errore_terms': 'Pour continuer, vous devez accepter les conditions générales du service',
      'accetto_clausole': 'J\'accepte expressément les clauses abusives énumérées à l\'art.14 des <a href="$terms$">Conditions Générales</a> du service',
      'acconsento_trattamento': 'Je consens au traitement de mes données personnelles à des fins promotionnelles comme indiqué dans la <a href="$privacy$">Politique de Confidentialité</a>',
      'acconsento_comunicazione': 'Je consens à la communication de mes données personnelles à des tiers à des fins de marketing, comme indiqué dans la <a href="$privacy$">Politique de Confidentialité</a>',
      'dichiaro_maggiorenne': 'Je confirme que je suis majeur',
      'cliccando_accetti':'En cliquant sur S\'inscrire, vous déclarez avoir lu et accepté la <a href="$privacy$">Politique de Confidentialité</a> et les <a href="$terms$">Conditions Générales</a> du service',
      'orientamenti_sessuali':'Je donne mon consentement exprès au traitement des données susceptibles de révéler mes préférences et orientations sexuelles, comme indiqué dans la <a href="$privacy$">Politique de Confidentialité</a>'
     },
     'photoItem':{
      'bottone_chat':'Bavarder',
      'bottone_like':'J\'aime',
      'bottone_profilo':'Profil',
      'registrati_gratis':'Enregistrez-vous gratuitement',
      'anni':'années'
    },
    'create_list':{
      'hai_ricevuto_like':'Vous avez reçu un like',
      'hai_ricevuto_visita':'A visité votre profil',
      'ha_rispost_like':'Elle a répondu à ton like!',
      'non_letto':'NON LU',
      'nessuna_notifica':"Vous n'avez encore reçu aucune notification",
      'nessun_messaggio':'Vous n\'avez encore reçu aucun message, ajoutez une photo de profil et utilisez la page Match pour envoyer quelques Likes.',
      'mi_piace':'J\'aime',
      'elimina_chat':'Supprimer la conversation',
      'sei_sicuro':'Êtes-vous sûr ?',
      'si':'Oui',
      'no':'Non'

    },
     'navbar_desktop':{
      'cerca': 'Chercher',
      'messaggi': 'Messages',
      'profilo':'Profil',
      'registrati':'Enregistrez-vous',
      'vip':'VIP',
      'incentive_menu':'Inscrivez-vous pour recevoir plus de messages',
      'messaggi_restanti':'Crédits messages',
      'rimanenti':'restantes',
      'logout':'Se déconnecter',
      'attiva_notifiche':'Activer les notifications',
      'notifiche':'Notifications',
      'match':'Match',
    },
    'creditCardForm':{
      'numero_carta': 'Numéro de carte',
      'nome_intestatario': 'Prénom du titulaire',
      'cognome_intestatario': 'Nom du titulaire',
      'scadenza': 'Expiration',
      'CVC': 'CVC',
      'continua': 'CONTINUER',
      'tasto_riprova': "RÉESSAYER",
      'carta': 'Carte de crédit',
      'nome': 'Prénom',
      'cognome': 'Nom',
      'disclaimer_fluxid0000': 'En cliquant sur continuer vous acceptez les <a href="$terms$"> Conditions Générales</a> et la <a href="$privacy$"> Politique de Confidentialité </a>',
      'disclaimer': 'En cliquant sur continuer vous acceptez les <a> Conditions Générales</a> et la <a> Politique de Confidentialité </a>',
      'pagamento_sicuro': 'Paiement Sécurisé',
      'descriptor': 'Nous nous soucions de votre vie privée et respectons votre confidentialité. Le débit effectué sur votre carte de crédit sera répertorié sous le nom $descriptor$ sur votre relevé',
      'errore': 'Erreur',
      'qualcosa_storto': 'Quelque chose s\'est mal passé',
      'cambia_carta': 'Essayez immédiatement avec une autre carte pour continuer à chatter ou changez de moyen de paiement',
      'cvv_errato': 'Le CVV/CVC n\'est pas correct. Corrigez le CVV/CVC ou changez de moyen de paiement pour continuer à chatter.',
      'fondi_insufficenti': 'Il semble que votre carte n\'ait pas de fonds ou ait atteint la limite de dépense. Nous vous invitons à vérifier ou à changer de moyen de paiement',
      'persa_rubata': 'Carte non utilisable. Essayez immédiatement avec une autre carte ou changez de moyen de paiement pour continuer à chatter',
      'scaduta': 'La carte que vous avez utilisée est expirée. Mettez à jour la carte ou changez de moyen de paiement pour continuer à chatter',
      'gia_processata': 'Cette carte a déjà été refusée. Veuillez essayer une nouvelle carte.',
      'numero_carta_non_valido': 'Vérifiez que les données de votre carte soient correctes pour continuer à chatter',
      'riprova': 'Tentative supplémentaire requise. Dans les prochaines étapes, vous serez redirigé vers le site de votre banque pour vérifier votre identité. Vous pourrez recevoir un SMS ou une notification sur l\'application de votre banque.',
      'blacklisted': 'Votre carte est sur liste noire',
      'generico': 'Carte refusée. Essayez immédiatement avec une autre carte pour continuer à chatter ou changez de moyen de paiement',
      '3ds': 'Tentative supplémentaire requise',
      'verifica_fallita': 'La vérification requise par votre banque pour confirmer votre identité n\'a pas abouti',
      'success': 'Merci, le paiement a été effectué avec succès. Continuez à chatter et bonne chance pour votre prochain rendez-vous',
      'consiglio_generico': 'Essayez immédiatement avec une autre carte pour continuer à <span className="special_bold">CHATTER</span>',
      'consiglio_insufficent_fund': 'Votre carte n\'est actuellement pas utilisable en raison de fonds insuffisants, changez de carte pour continuer à chatter',
      'consiglio_3ds': 'Dans les prochaines étapes, vous serez redirigé vers le site de votre banque pour vérifier votre identité. Confirmez la notification qui arrivera de votre banque',
      'disclaimer_verifica_eta': 'En cliquant sur CONTINUER, vous acceptez nos Conditions d\'utilisation et notre Politique de confidentialité, et des frais de vérification de 0,01€ peuvent être facturés.',
      'descrizione_pending': 'Il semble que votre banque prenne plus de temps que prévu. Continuez à naviguer, nous vous donnerons les crédits dès que l\'opération sera approuvée',
      'titolo_cvv': 'Corrigez CVV/CVC',
      'titolo_fondi_insufficenti': 'Carte insuffisante?',
      'titolo_persa_rubata': 'Carte non utilisable',
      'titolo_generico': 'Carte refusée',
      'titolo_pending': 'L\'opération est toujours en cours',
      'titolo_success': 'Paiement accepté',
      'titolo_verifica_fallita': 'Erreur d\'achat',
      'titolo_riprova': 'Tentative supplémentaire requise',
      'cambia_metodo_pagamento': 'Ce moyen de paiement a été bloqué en raison d\'un nombre excessif de tentatives échouées. Veuillez essayer un autre moyen de paiement.',
      'open': 'Nous attendons que votre banque confirme le paiement. Les crédits seront crédités en cas de résultat positif. Cela prend généralement quelques minutes',
      'titolo_open': 'Paiement en attente',
      'titolo_canceled': 'Paiement annulé',
      'descrizione_canceled': 'Vous avez annulé le paiement. Réessayez pour continuer à chatter',
      'titolo_problemi_api': 'Transaction échouée',
      'descrizione_problemi_api': 'Il semble y avoir des problèmes avec ce moyen de paiement. Essayez avec un autre moyen',
      'pagamento_in_corso':'Paiement en cours...',
      'attendi_un_minuto':'Un paiement est déjà en cours, veuillez attendre une minute avant de faire d\'autres achats.',
      'waiting':'Nous attendons que votre banque confirme le paiement. Attendez un moment s\'il vous plaît.',
      'titolo_waiting': 'Encore un instant',
      'titolo_pacchettone': 'Félicitations!',
      'descrizione_pacchettone': 'Nous voulons récompenser votre engagement<br>avec une <strong>surprise spéciale</strong> pour vous!',
      'prendine_un_altro': 'Prenez-en un autre à moitié prix!',
      'disclaimer_opale': 'Essai gratuit du service de coaching en séduction en ligne.<br> L\'essai de 10 jours vous permet de parler avec des coachs chaque jour, de recevoir des conseils personnalisés et d\'accéder à des articles exclusifs. Après la période d\'essai, le service se renouvelle automatiquement à 19,90 € tous les 14 jours, jusqu\'à annulation.'
    },
    'payment_page':{
      'pagamento_sicuro':'Paiement sécurisé',
      'dati_protetti':'Données de la carte protégées par cryptage SSL',
      'non_paghi_nulla':'N.B Pour vérifier votre compte, vous ne paierez rien. Mais insérer une carte active est le seul moyen de prouver que vous êtes un vrai utilisateur comme tous les utilisateurs vérifiés',
      'verifica_profilo':'Vérifier le profil',
      'stai_acquistando':'Vous achetez',
      'procedura':'Trámite de verificación de edad GRATIS',
    'nessun_addebito':'<strong>€ 0.00 - Sin cargos</strong><br>¡SOLO ADULTOS!',
    'inserisci_e_verifica':'Inserta tu tarjeta<br>y verifica que eres mayor de <strong>18 años</strong>',
    'nessun_abbonamento':'Ceci n\'est PAS un abonnement. Votre carte de crédit n\'aura AUCUNE rétrofacturation.',
    'scegli_metodo':'Comment veux-tu continuer?',
    "attiva_pass": "Activez votre <strong>PASSE</strong> pour chatter sans limites",
    'coda_discplaimer':'En raison du grand nombre d\'utilisateurs qui souhaitent vérifier leur compte, vous êtes dans une file d\'attente. Dès que possible, vous serez redirigé vers la page de paiement pour terminer la procédure de vérification.',
    'garanzia_di_rimborso':'Garantie de remboursement',
    'garanzia_di_rimborso_text':'Vous avez droit à un remboursement complet<br/> si vous n\'êtes pas satisfait.',
    'processando_pagamento':'Nous traitons votre paiement, veuillez patienter...',

    },
    'pianiAbbonamento':{
      'disclaimer':'En choisissant un plan d\'abonnement, vous acceptez les <a href="/legal/terms">Conditions générales</a> et la <a href="/legal/terms#billingPolicy">politique de facturation</a>',
      'disclaimer2':'*Tous les plans incluent le renouvellement automatique.',
      'disclaimer3':'**En choisissant un plan d\'abonnement, vous acceptez les <a href="/legal/terms">Conditions générales</a> et la <a href="/legal/terms#billingPolicy">politique de facturation</a>.',
      'disclaimer4':'***En choisissant un plan d\'abonnement, vous acceptez les <a href="/legal/terms">Conditions générales</a> et la <a href="/legal/terms#billingPolicy">politique de facturation</a>.',
      'disclaimer5': 'Tous les plans sont renouvelés automatiquement.',
      'errore':'Erreur',
      'qualcosa_storto':'Un problème est survenu',
      'header_chatta_senza_limiti':' Vuoi chattare senza limiti con <strong>$angel$</strong>?',
      'header_fine_like':'Vuoi inviare LIKE illimitati?',
      'header_messaggio_offuscato':' Vuoi leggere il messaggio di <strong>$angel$</strong>?',
      'header_paginazione':'Vuoi vedere tutte le donne in linea?',
      'header_cambio_regione':'Vuoi cercare le donne in altre regioni?',
      'testo_verifica_eta':'Per garantire la <strong> sicurezza </ strong> dei nostri utenti <strong> dobbiamo verificare che tu </ strong> <br> <strong> sia maggiorenne </ strong>',
      'testo_bottone_verifica_eta':'IO HO 18+ ANNI',
      'aggiungiamo_crediti':'Nous ajoutons vos crédits',
       'altri_uomini': '<i>D\'autres hommes pourraient lui écrire</i>',
      'vuoi_continuare': 'Voulez-vous continuer à discuter avec <strong>$angel$</strong> et avec toutes les autres femmes ?',
      'redirigendo': 'Vous serez redirigé vers la page de paiement dans quelques secondes',
      'crediti': 'Crédits',
      'approfitta_ora': 'Profitez dès maintenant de <strong>cette offre</strong><br />pour continuer à recevoir des avantages.',
      'like_illimitati': 'Likes illimités<br />Chatter avec qui vous voulez',
    },
    'passwordReset':{
      'caricando':'Chargement...',
      'procedura':'Entrez le nouveau mot de passe',
      'password':'Nouveau mot de passe',
      'ripeti':'Répétez le mot de passe',
      'invia':'Envoyer',
      'non_corrispondono':'Le mot de passe dû ne correspond pas',
      'passwordCambiata':'Mot de passe remplacé avec succès. Aller à la page de connexion',
      'token_expired':'La procédure de réinitialisation du mot de passe a déjà été effectuée. Réessayer'
    }, 
    'errorHandler':{
      'email_esistente':'Votre e-mail existe déjà. Essayez de vous connecter',
      'utente_non_trovato':'Nom d\'utilisateur ou mot de passe invalide',
      'qualcosa_storto':'Une erreur s\'est produite. Veuillez réessayer',
      'fingerprint':'Il s\'avère que vous êtes déjà inscrit $email$, essayez de vous connecter',
      'email_non_valida':'L\'e-mail est mal écrit. Vérifier la ponctuation et les espaces',
      'email_vietata':'Cet e-mail ne peut pas être utilisé. Utilisez-en un autre',
      'troppi_tentativi':'Vous avez fait trop de tentatives d\'inscription',
      'account_disabilitato':'Votre compte a été désactivé. Veuillez contacter le service client',
      'welcome_gia_inviata': 'L\'email de bienvenue a déjà été envoyée à cette adresse <strong class="blink">vérifiez le dossier <blink>Spam</blink> ou <blink>Courrier indésirable</blink></strong>.'
    },
    'logo':{
      'url':'/img/logo_fr.png'
    },
    'ok':{
      'congratulazioni':'Toutes nos félicitations!!',
      'utente_premium':'Vous êtes devenu un utilisateur premium',
      'bottone_chat':'Aller aux chats'
    },
    'ko':{
      'ops':'Oops!',
      'qualcosa_storto':'Un problème est survenu',
      'bottone_indietro':'Réessayer',
    },
    'searchFilters':{
      'titolo_popup':'Sélectionnez la ville où vous souhaitez voir les femmes disponibles',
      'seleziona':'Sélectionner',
      'seleziona_regione':'Choisissez une région'
    },
    'footer':{
      'faq':'FAQ',
      'termini':'Termes et conditions',
      'privacy':'Politique de confidentialité',
      'cookie':'Politique relative aux cookies',
      'contact_us':'Nous contacter',
    },
    'chats':{
      'nessun_messaggio':'Vous n\'avez pas encore de messages'
    },
    'contactUs':{
      'contattaci':'Nous contacter',
      'per_ricevere':'Pour recevoir une assistance directe, contactez-nous en utilisant le formulaire approprié dans cette page ou aux adresses suivantes',
      'caricando':'Chargement...',
      'grazie':'Merci, votre message a été repris'
    },
    'landingAutologin':{
      'titolone': 'IMPORTANTE',
      'testo':'<strong>$angel$</strong> te envió un mensaje. Recuerda que tú y otros usuarios de este club buscan diversión, no una relación. Muchos están casados ​​y son infelices, otros son madres solteras. Todos viven en $regione$ si conoces a uno o más de ellos te pedimos que mantengas su identidad en secreto dentro de este club de sexo. Para ver el mensaje <strong>$angel$</strong> y aceptar las reglas del club, haga clic en continuar.',
      'pulsante':'CONTINÚA'
    },
    'landingAutosignup':{
      'titolone': 'IMPORTANTE',
      'testo':'<strong>$angel$</strong> te está buscando. Recuerda que tú y otros usuarios de este club buscan diversión, no una relación. Muchos están casados ​​y son infelices, otros son madres solteras. Todos viven en $regione$ si conoces a uno o más de ellos te pedimos que mantengas su identidad en secreto dentro de este club de sexo. Para ver el mensaje <strong>$angel$</strong> y aceptar las reglas del club, haga clic en continua.',
      'pulsante':'CONTINÚA'
    },
    'telegramPush':{
      'titolo':'Ne manque aucun message',
      'titolo_nome':'$nome$ va te répondre.',
      'sottotitolo':'Où veux-tu être prévenu tout de suite ?',
      'consigliato':'Conseillé',
      'presto':'Bientôt',
      'push_titolo':'Notifications sur le téléphone',
      'push_testo':'Un clic, aucune appli à installer.',
      'push_attivo':'Activées. On te prévient sur ton téléphone.',
      'push_ios':'Ajoute d\'abord le site à l\'écran d\'accueil.',
      'telegram_testo':'Instantané et discret. Tu le désactives quand tu veux.',
      'telegram_attivo':'Activé. On te prévient ici.',
      'whatsapp_testo':'Le message arrive là où tu discutes déjà.',
      'whatsapp_messaggio':'Bonjour ! Activez les notifications pour $email$',
      'passo_1':'Touche Partager en bas de Safari',
      'passo_2':'Choisis « Sur l\'écran d\'accueil »',
      'passo_3':'Ouvre le site depuis l\'icône et reviens ici',
      'push_negato':'Tu as bloqué les notifications : réactive-les dans les réglages du navigateur.',
      'push_non_supportato':'Ce navigateur ne gère pas les notifications. Ouvre le site dans Chrome ou Safari, ou choisis Telegram.',
      'push_errore':'Impossible de les activer. Réessaie dans un instant.',
      'fatto':'C\'est fait. Désormais on te prévient ici.',
      'torna_chat':'Retour au chat',
      'torna_chat_nome':'Retour au chat avec $nome$'
    },
    'cookie':{
      'disclaimer': '<p>Este sitio utiliza cookies o otras herramientas técncias y, previo consentimiento, también cookies de perfil u otras herramientas de seguimiento, también de terceros, para enviarte publicidad personalizada y ofrecerte servicios en línea con tus preferencias, así como la supervisión del comportamiento de los visitantes. Si quieres saber más, consulta la Política de Cookies</p><p>Para seleccionar de forma analítica solamente algunos fines, terceros y cookies, es posible hacer clic en «Selecciona tus preferencias».</p><p>Si cierras este banner pinchando en la «X», seguirás navegando por el sitio sin cookies ni otras herramientas de seguimiento que no sean las técnicas.</p>',
    'button':'Aceptar todas las cookies',
    'rifiuta':'Rechazar todo'
    },
    'doi_popup':{
      'complimenti':'¡Bien hecho!',
      'attiva_account': 'Activez votre compte',
  'conferma': 'Confirmez l\'adresse maintenant',
      'titolo':'Tu perfil en $servizio$ ha sido creado con éxito',
      'descrizione': 'Nous vous avons envoyé un email à :',
      'indirizzo_indicato':'Tu correo electrónico:',
      'se_sbagliata':'Si ha ingresado la dirección incorrecta, puede cambiarla ingresando la correcta en el siguiente campo y haciendo clic en "Envíar"',
      'cambia_mail':'Cambiar la dirección de correo electrónico',
      'invia':'Envíar',
      'errore_stessa_mail':'Ingresaste el mismo correo. Ya te hemos enviado el mensaje a esa dirección. Por favor espera o revisa tu carpeta de spam',
      'importante':'Importante:',
      'messaggio_ok':'Hemos enviado un mensaje a la nueva dirección de correo electrónico.',
      'errore_su_cambio_email':'no fue posible cambiar el correo electronico',
      'punto1':'<strong>Verifique</strong> su carpeta <strong>"Spam / Junk Mail"</strong> para asegurarse de que el correo electrónico no haya llegado allí',
      'punto2':'El correo electrónico de activación puede tardar hasta 5 minutos en llegar.',
      'punto3':'Márcanos como <strong>"No es spam/Correo no deseado"</strong> para asegurarte de recibir todos los correos electrónicos importantes de $servizio$'
  
    },
    'find':{
      'donne_disponibili':'Mujeres Disponibles en el área de'
    },
    'tooltip':{
      'titolo_attiva_notifiche':'💌 Activar las notificaciones',
      'attiva_notifiche':'-- No pierdas la oportunidad de conocer a las mujeres que te escriben o visitan tu perfil. ¡Activa las notificaciones de inmediato, tendrás más posibilidades de acertar en el objetivo! 😍 --',
      'bottone_attiva_notifiche':'Activar ahora!'
    },
    'unsubscribe':{
      'titolo':'Se désinscrire de la Newsletter',
      'sottotitolo':'Nous sommes désolés d\'apprendre que vous souhaitez vous désinscrire de notre newsletter. Cliquez sur le bouton ci-dessous pour confirmer votre désinscription. Si vous changez d\'avis, vous pouvez toujours vous réinscrire à l\'avenir !',
      'testo_bottone':'Se désinscrire',
      'testo_popup':'<strong>Désinscription réussie !</strong><br> Vous serez redirigé vers la page d\'accueil du site'
    },
    'match':{
      'manda_invito':'Envoyer une invitation',
      'anni':'ans',
      'su_di_me':'À propos de moi',
    },
    'recensioni':{
      'cosa_dicono':'<strong>Ce que</strong> disent les utilisateurs sur le web'
    }

  }
